// customerService.js
import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class CustomerService {
  fetchCustomers = (
    page = 1,
    page_size = 10,
    kycFilter = '',
    searchQuery = '',
    searchField = '',
    todayRegistrations = null,
    fromDate = '',
    toDate = '',
  ) => {
    // API expects page (1-indexed) and pageSize - not skip/limit
    let url = `${BASE_URL}/v1/user/users/all?page=${page}&pageSize=${page_size}`;

    // Only add kycStatus if filter is provided
    if (kycFilter) {
      url += `&kycStatus=${encodeURIComponent(kycFilter)}`;
    }

    // Handle search based on searchField type
    if (searchQuery && searchField) {
      // Map search field names to API parameter names
      const searchParamMap = {
        phone: 'phone',
        email: 'email',
        name: 'name',
      };

      const apiParamName = searchParamMap[searchField] || searchField;
      url += `&${apiParamName}=${encodeURIComponent(searchQuery.trim())}`;
    }

    // Only add todayRegistrations parameter when explicitly provided (not null)
    // This allows passing false value when Today's button is toggled off
    if (todayRegistrations !== null && todayRegistrations !== undefined) {
      url += `&todayRegistrations=${todayRegistrations}`;
    }

    if (fromDate) {
      url += `&fromDate=${fromDate}`;
    }

    if (toDate) {
      url += `&toDate=${toDate}`;
    }

    return axiosInstance.get(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  };

  deleteCustomer = (id) => {
    return axiosInstance.delete(`${BASE_URL}/v1/User/users/${id}`);
  };

  getKycDocuments = (userId) => {
    return axiosInstance.get(
      `${BASE_URL}/v1/User/users/${userId}/kyc-documents`,
    );
  };

  manualKycApproval = (userId, approvalData) => {
    return axiosInstance.put(
      `${BASE_URL}/v1/User/users/${userId}/kyc-approval`,
      {
        isKycCompleted: true,
        approvedBy: approvalData.adminId,
        approvalReason: approvalData.reason,
        approvalDate: new Date().toISOString(),
      },
    );
  };

  manualKycRejection = (userId, rejectionData) => {
    return axiosInstance.put(
      `${BASE_URL}/v1/User/users/${userId}/kyc-rejection`,
      {
        isKycCompleted: false,
        rejectedBy: rejectionData.adminId,
        rejectionReason: rejectionData.reason,
        rejectionDate: new Date().toISOString(),
      },
    );
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CustomerService();
